export enum HttpStatusEnum {
	NotFound = 404,
	Ok = 200,
	BadRequest = 400,
	Unauthorized = 401,
	Forbidden = 403,
	MultiStatus = 207,
	InternalServerError = 500,
	ServiceUnavailable = 503,
}
